import { message as $message } from 'antd'
import { queryRedPointMenuList } from '@/services/supplier'

const RedPointModel = {
    namespace: 'redPoint',
    state: {
        redDot: {}
    },
    effects: {
        *query({ payload }, { call, put }) {
            try {
                const res = yield call(queryRedPointMenuList, {
                    menuRedPoints: payload.params
                    // menuRedPoints: ['ORDER', 'SETTLEMENT']
                    // 后端是支持做成全局的，前端目前先使用结算单
                })
                if (res.success) {
                    if (res.data) {
                        yield put({
                            type: 'updateRedDot',
                            payload: {
                                redDot: { ...res.data }
                            }
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        }
    },
    reducers: {
        updateRedDot(state, { payload }) {
            return {
                redDot: {
                    ...state.redDot,
                    ...payload.redDot
                }
            }
        }
    }
}

export default RedPointModel
